import { Component } from "react";
import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "@/components/CartDrawer";
import HomePage from "@/pages/HomePage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminOrders from "@/pages/AdminOrders";
import InfosPage from "@/pages/InfosPage";
import TestPayment from "@/pages/TestPayment";

function ScrollAndLenis() {
    const location = useLocation();

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [location.pathname]);

    return null;
}

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    render() {
        if (this.state.error) {
            return (
                <div className="min-h-screen bg-spidey-bg flex items-center justify-center p-6">
                    <div className="text-center max-w-md">
                        <h1 className="font-display uppercase text-3xl text-white">
                            La toile s'est déchirée
                        </h1>
                        <p className="mt-3 text-sm text-zinc-500">
                            Une erreur est survenue. Recharge la page pour revenir à la boutique.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <CartProvider>
                    <ScrollAndLenis />
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/cancel" element={<PaymentCancel />} />
                        <Route path="/ventes" element={<AdminOrders />} />
                        <Route path="/infos/:slug" element={<InfosPage />} />
                        <Route path="/test-paiement" element={<TestPayment />} />
                        <Route path="*" element={<HomePage />} />
                    </Routes>
                    <CartDrawer />
                    <Toaster richColors position="top-center" theme="dark" />
                </CartProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
